export default __webpack_public_path__ + "static/media/t2.f0207c8a.svg";